<template>
    <rkm-overlay>
        <rkm-layout-body title="Lista para inventário">
            <template v-slot:actions>
                <rkm-button
                    :disabled="!hasMaterial"
                    @click="save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>

                <rkm-button
                    :disabled="!hasMaterial"
                    @click="finalizar()"
                    color="outline-success"
                >
                    Finalizar
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List
                    :key="listKey"
                    @count-change="hasMaterial = $event > 0"
                    @save="++listKey"
                    ref="List"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/almoxarifado/inventario/List'

export default {
    components: { List },
    data: () => ({
        hasMaterial: false,
        listKey: 1,
    }),
    methods: {
        save() {

            this.showConfirmation(
                'Ao salvar o estoque não será ajustado, apenas serão salvas as contagens para finalização posterior. '
                    + 'Deseja continuar?',
                async () => this.$refs.List.save()
            )
        },
        finalizar() {

            this.showConfirmation(
                'Ao finalizar o estoque será ajustado de acordo com as contagens informadas. Deseja continuar?',
                async () => this.$refs.List.finalizar()
            )
        }
    }
}
</script>